import { partyRoleApiSchema } from "@/components/Forms/schema/partyRoleSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const partyRoleSelector = createResourceSelector({
    type: "partyRole",
    attributesSchema: partyRoleApiSchema,
});

export type PartyRoleApi = ReturnType<typeof partyRoleSelector>;

export const useFetchPartyRole = (partyRoleId: string): UseQueryResult<PartyRoleApi> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["party-role"],
        queryFn: async ({ signal }) => {
            const url = apiUrl(`/party-role/get/${partyRoleId}`);

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: partyRoleSelector,
    });
};
